import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { emailApi } from '../utils/api';
import toast from 'react-hot-toast';
import { useLanguageStore } from '../stores/languageStore';
import { t } from '../stores/languageStore';

const JoinUs: React.FC = () => {
  const { language } = useLanguageStore();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telegram: '',
    role: '',
    reason: '',
    agree: false
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // 表单验证
    if (!formData.name || !formData.email || !formData.telegram || !formData.role || !formData.reason || !formData.agree) {
      toast.error('请填写所有必填项');
      return;
    }

    setLoading(true);
    try {
      const emailContent = `
申请类型: 加入我们

申请人信息:
姓名: ${formData.name}
邮箱: ${formData.email}
Telegram: ${formData.telegram}
申请角色: ${formData.role === 'volunteer' ? '志愿者' : formData.role === 'channel_owner' ? '频道主' : '频道管理员'}

申请理由:
${formData.reason}
      `;

      await emailApi.sendEmail({
        to: '18696231271@163.com',
        subject: '[桃花坛] 加入我们申请',
        content: emailContent
      });

      toast.success('申请提交成功，我们会尽快审核并与您联系');
      // 重置表单
      setFormData({
        name: '',
        email: '',
        telegram: '',
        role: '',
        reason: '',
        agree: false
      });
    } catch (error) {
      console.error('发送邮件失败:', error);
      // 尝试获取更详细的错误信息
      let errorMessage = '申请提交失败，请稍后重试';
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'object' && error !== null && 'response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-pink-500 via-rose-500 to-red-500 rounded-2xl p-8 text-white shadow-xl">
        <h1 className="text-3xl font-bold mb-2">{t('joinUs.title')}</h1>
        <p className="text-pink-100">{t('joinUs.subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-lg transition-shadow">
          <div className="w-16 h-16 rounded-2xl bg-pink-100 flex items-center justify-center mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-pink-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-slate-900 mb-3">{t('joinUs.volunteer')}</h3>
          <p className="text-slate-600 mb-4">
            {t('joinUs.volunteerDesc')}
          </p>
          <ul className="space-y-2 text-sm text-slate-600 mb-6">
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Maintain community order and handle violations' : '维护社区秩序，处理违规内容'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Answer newcomer questions and provide tech support' : '回答新手问题，提供技术支持'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Participate in community activity planning' : '参与社区活动策划和执行'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Assist with content review and management' : '协助内容审核和管理'}</span>
            </li>
          </ul>
          <button className="w-full py-2 bg-pink-600 text-white rounded-xl hover:bg-pink-700 transition-colors">
            {language === 'en' ? 'Apply as Volunteer' : '申请成为志愿者'}
          </button>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-lg transition-shadow">
          <div className="w-16 h-16 rounded-2xl bg-purple-100 flex items-center justify-center mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-slate-900 mb-3">{t('joinUs.channelOwner')}</h3>
          <p className="text-slate-600 mb-4">
            {t('joinUs.channelOwnerDesc')}
          </p>
          <ul className="space-y-2 text-sm text-slate-600 mb-6">
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Create and manage professional tech channels' : '创建和管理专业技术频道'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Organize channel content and activities' : '组织频道内的内容和活动'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Attract and manage channel members' : '吸引和管理频道内的用户'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Maintain professional atmosphere' : '维护频道内的专业氛围'}</span>
            </li>
          </ul>
          <button className="w-full py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors">
            {language === 'en' ? 'Apply as Channel Owner' : '申请成为频道主'}
          </button>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-lg transition-shadow">
          <div className="w-16 h-16 rounded-2xl bg-green-100 flex items-center justify-center mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-slate-900 mb-3">{t('joinUs.channelAdmin')}</h3>
          <p className="text-slate-600 mb-4">
            {t('joinUs.channelAdminDesc')}
          </p>
          <ul className="space-y-2 text-sm text-slate-600 mb-6">
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Assist channel owner with channel management' : '协助频道主管理频道'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Review channel content' : '审核频道内的内容'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Organize channel activities' : '组织频道内的活动'}</span>
            </li>
            <li className="flex items-start">
              <span className="text-green-500 mr-2">•</span>
              <span>{language === 'en' ? 'Maintain channel order' : '维护频道内的秩序'}</span>
            </li>
          </ul>
          <button className="w-full py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors">
            {language === 'en' ? 'Apply as Channel Admin' : '申请成为频道管理员'}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
        <h2 className="text-xl font-bold text-slate-900 mb-4">{t('joinUs.applyProcess')}</h2>
        <div className="space-y-4">
          <div className="flex items-start">
            <div className="w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 font-bold mr-4 flex-shrink-0">1</div>
            <div>
              <h3 className="font-semibold text-slate-900 mb-1">{t('joinUs.submitApplication')}</h3>
              <p className="text-slate-600">{t('joinUs.submitApplicationDesc')}</p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 font-bold mr-4 flex-shrink-0">2</div>
            <div>
              <h3 className="font-semibold text-slate-900 mb-1">{t('joinUs.review')}</h3>
              <p className="text-slate-600">{t('joinUs.reviewDesc')}</p>
            </div>
          </div>
          <div className="flex items-start">
            <div className="w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 font-bold mr-4 flex-shrink-0">3</div>
            <div>
              <h3 className="font-semibold text-slate-900 mb-1">{t('joinUs.approved')}</h3>
              <p className="text-slate-600">{t('joinUs.approvedDesc')}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
        <h2 className="text-xl font-bold text-slate-900 mb-4">{t('joinUs.faq')}</h2>
        <div className="space-y-4">
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">{t('joinUs.requirements')}</h3>
            <p className="text-slate-600">
              {t('joinUs.requirementsAnswer')}
              {language === 'en' ? (
                <>
                  1. Be familiar with community content<br/>
                  2. Have good communication skills<br/>
                  3. Willing to invest time and effort in the community<br/>
                  4. Follow community rules and code of conduct
                </>
              ) : (
                <>
                  1. 熟悉社区相关内容<br/>
                  2. 有良好的沟通能力<br/>
                  3. 愿意为社区付出时间和精力<br/>
                  4. 遵守社区规则和行为准则
                </>
              )}
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">{t('joinUs.volunteerBenefits')}</h3>
            <p className="text-slate-600">
              {t('joinUs.volunteerBenefitsAnswer')}
              {language === 'en' ? (
                <>
                  1. Improve your abilities and communication skills<br/>
                  2. Meet like-minded friends<br/>
                  3. Gain recognition and respect from the community<br/>
                  4. Have the opportunity to participate in community decisions
                </>
              ) : (
                <>
                  1. 提升自己的能力和沟通技巧<br/>
                  2. 结识更多志同道合的朋友<br/>
                  3. 获得社区的认可和尊重<br/>
                  4. 有机会参与社区的决策和发展
                </>
              )}
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-slate-900 mb-1">{t('joinUs.createBoard')}</h3>
            <p className="text-slate-600">
              {t('joinUs.createBoardAnswer')}
              {language === 'en' ? (
                <>
                  1. Explain the theme and positioning of the board you want to create<br/>
                  2. Provide proof of your relevant experience and capabilities<br/>
                  3. Explain how you will manage and operate this board<br/>
                  4. Submit a detailed board operation plan
                </>
              ) : (
                <>
                  1. 说明你想创建的版块主题和定位<br/>
                  2. 提供你的相关经验和能力证明<br/>
                  3. 说明你将如何管理和运营这个版块<br/>
                  4. 提交一份详细的版块运营计划
                </>
              )}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-pink-50 via-rose-50 to-red-50 rounded-2xl p-6 shadow-sm">
        <div className="text-center">
          <h2 className="text-xl font-bold text-slate-900 mb-3">{t('joinUs.readyToJoin')}</h2>
          <p className="text-slate-600 mb-6">
            {t('joinUs.readyToJoinDesc')}
          </p>
          <button className="px-8 py-3 bg-pink-500 text-white rounded-xl hover:bg-pink-600 transition-colors">
            {t('joinUs.applyNow')}
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
        <h2 className="text-xl font-bold text-slate-900 mb-4">{t('joinUs.applicationForm')}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">{t('joinUs.name')}</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder={t('joinUs.enterName')}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">{t('joinUs.email')}</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder={t('joinUs.enterEmail')}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">{t('joinUs.telegram')}</label>
            <input
              type="text"
              name="telegram"
              value={formData.telegram}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder={t('joinUs.enterTelegram')}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">{t('joinUs.applyRole')}</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">{t('joinUs.selectRole')}</option>
              <option value="volunteer">{t('joinUs.volunteer')}</option>
              <option value="channel_owner">{t('joinUs.channelOwner')}</option>
              <option value="channel_admin">{t('joinUs.channelAdmin')}</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">{t('joinUs.applyReason')}</label>
            <textarea
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              rows={4}
              className="w-full px-4 py-2 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder={t('joinUs.enterReason')}
            ></textarea>
          </div>
          <div className="flex items-center space-x-2">
            <input 
              type="checkbox" 
              id="agree" 
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
              className="w-4 h-4" 
            />
            <label htmlFor="agree" className="text-sm text-slate-700">
              {t('joinUs.agreeRules')}
            </label>
          </div>
          <button 
            type="submit" 
            disabled={loading}
            className="w-full py-3 bg-pink-600 text-white rounded-xl hover:bg-pink-700 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {loading ? t('joinUs.submitting') : t('joinUs.submitApplicationBtn')}
          </button>
        </form>
      </div>
    </div>
  );
};

export default JoinUs;